import React, { useState, useEffect } from "react";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { useNavigate, Routes, Route } from "react-router-dom";
import { useObserver } from "mobx-react";
import "./profile.css";
import {
  MdOutlineEmojiEvents,
  MdOutlineLogout,
} from "react-icons/md";
import { MdOutlineCancel } from "react-icons/md";
import Dashboard from "./dashboard";
import ReportScreen from ".././reusble_components/reportScreen";
import BasicDetails from "./basicDetails";
import Learn from "./learn";
import { GoHome } from "react-icons/go";
import {
  IoDiamondOutline,
  IoDocumentTextOutline,
  IoSettingsOutline,
} from "react-icons/io5";
import MobileBottomNavBar from "../navbar/mobileNavbar";
import { useStores } from "../../store/index";
import LearninngTab from "../learn/learningTab";
import Mistakes from "./mistakes";
import {
  loginWarningImage,
} from "../../helpers/constantVariables";
import {
  getLogoBySubdomain,
  getSmallLogoForWhiteLabeling,
  name,
  view,
} from "../../services/white_label";
import Tooltip from "../reusble_components/tooltip";
import { useLocation } from "react-router-dom";
import CreateMockTest from "../mockTest/CreateMockTest";
import Career from "./Career";
import CareerLanding from "../career/careerLanding";
import CareerDetails from "../career/CareerDetails";
import { apiPostPut } from "../../api/api_methods";
import { MeetingCreationForm } from "./MeetingCreation";
import { toJS } from "mobx";
import Internship from "../career/JobInternship";
import History, { JobPostReport } from "./history";
import JobDetails from "../../components/career/components/page";
import ResumeTotal from "../resume/resumetotal";
import Popup from "../reusble_components/popup";
import { setDataToLocalStorage } from "../../services/localStorage";
import MockExamReport from "./mockexamreport";
import HistoryPage from "../career/HistoryPage";
import AnimatedSearchBar from "../career/search";
import ResumeAnalyzer from "./resume/resumeAnalyzer";
import Subscription from "../reusble_components/Pricing/subscription";
import PricePlan from "../reusble_components/Pricing/pricePlans";
import TransactionCards from "../reusble_components/Pricing/transactionCards";
import { PiClipboardTextLight, PiSuitcaseSimpleLight } from "react-icons/pi";
import { VscHistory } from "react-icons/vsc";
import Report from "./resume/report";
import PricingPlans from "../reusble_components/Pricing/naukritube/pricingPlans";
import CheckoutPage from "../reusble_components/Pricing/naukritube/CheckoutPage";

export default function Profile() {
  const navigate = useNavigate();
  const { UserStore, LearningStore, CommonStore, PopupStore, RecuiterStore } =
    useStores();
  const [selectedItem, setSelectedItem] = useState(0);
  const [sidebarWidth, setSidebarWidth] = useState("5%");
  const [banner, setBanner] = useState(null);
  const [showTechFusionHeader, setShowTechFusionHeader] = useState(false);

  const handleLogoClick = () => {
    // Redirect to the main page
    navigate("/dashboard/dashboard");
  };

  const location = useLocation();

  useEffect(() => {
    if (UserStore.userPic) {
      setProfile(UserStore.userPic);
    } else {
      setProfile(userGoogleDetails?.pic);
    }
    if (location.pathname.includes("/dashboard/course")) {
      // If the user is viewing the course, set the sidebar width accordingly
      return setSidebarWidth("5%");
      // } else if (location.pathname.includes("/dashboard/resumedetails")) {
      //   // If the user is viewing the resumedetails, set the sidebar width accordingly
      //   setSidebarWidth("5%");
    } else {
      // Otherwise, set the default width
      // setSidebarWidth("12%");
      return;
    }
  }, [UserStore.userPic, location]);

  useEffect(() => {
    setProfile(userGoogleDetails?.pic);
  }, []);
  const getbanner = async () => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    const data = {
      clusterId: userDetails?.cluster,
    };
    const response = await apiPostPut(
      data,
      "/admin/get-active-banner?usedFor=student",
      "POST"
    );
    if (response.status === 200) {
      console.log("response", response.body.data);
      console.log("response", response.body.data);
      if (response.body.data < 0) {
        setShowTechFusionHeader(false);
      }

      setBanner(response.body.data);
      setShowTechFusionHeader(true);
    } else {
      setShowTechFusionHeader(false);
    }
  };
  const redirectToSignupPageWithCurrentUrl = () => {
    const currentPath = window.location.href;

    // set currentPath in local storage
    setDataToLocalStorage("redirectUrl", currentPath);

    const signupUrl = `/`;

    console.log(signupUrl);

    navigate(signupUrl);
  };
  useEffect(() => {
    if (!JSON.parse(localStorage.getItem("user"))?.role?.role) {
      PopupStore.setLoginWarning(true);
    }
  }, [selectedItem]);

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    const data = {
      clusterId: userDetails?.cluster,
    };

    if (!UserStore.bannerHit) {
      getbanner();
      UserStore.setBannerHit(true);
    }
    // const response = await apiPostPut( data,"/admin/active-banner", "POST");
    // if(response.status===200){
    //   console.log("response",response.data)
    // }
  }, []);

  // const userDetails = JSON.parse(localStorage.getItem("user"));
  const userGoogleDetails = JSON.parse(localStorage.getItem("user"));
  const [profile, setProfile] = useState(userGoogleDetails?.pic);
  const defaultProfile = UserStore.userPic;
  const loc = useLocation();

  const [activePlan, setActivePlan] = useState(null);

  useEffect(() => {
    const fetchSubscriptions = async () => {
      await UserStore.checkSubscription();
      const activeSubscription = UserStore.previousSubscriptions;
      console.log(toJS(activeSubscription), "activeSubscription");
      setActivePlan(toJS(activeSubscription));
    };

    fetchSubscriptions();
  }, []);

  const studentPlans = [
    {
      id: "67cac81dcc2bec83fe4e8a95",
      name: "Basic Plan",
      price: 599,
      originalPrice: "₹999",
      features: [
        { text: "Resume Analyser", available: true, value: 3 },
        { text: "AI Interviews", available: true, value: 3 },
        { text: "Internship Guarantee", available: false },
        { text: "Detailed Analytical Report", available: true },
        { text: "Days Interview Video Backup", available: true, value: 15 },
        { text: "Job Application", available: true, value: 1 },
        { text: "Profile Boost", available: false },
        { text: "Premium Account Badge", available: false },
        { text: "MCQ's", available: true, value: 3 },
        { text: "Days Validity", available: false, value: 30 },
        { text: "Alerts & Notifications", available: false },
        { text: "ATS", available: false },
        { text: "Performance Analytical Report", available: false },
      ],
    },
    {
      id: "67caca7ecc2bec83fe4e8aa4",
      name: "Starter Plan",
      price: 5999,
      originalPrice: "₹5,999",
      features: [
        { text: "Resume Analyser", available: true, value: 50 },
        { text: "AI Interviews", available: true, value: 50 },
        { text: "Internship Guarantee", available: false },
        { text: "Detailed Analytical Report", available: true },
        { text: "Days Interview Video Backup", available: true, value: 30 },
        { text: "Job Application", available: true, value: 30 },
        { text: "Profile Boost", available: true },
        { text: "Premium Account Badge", available: false },
        { text: "MCQ's", available: true, value: 30 },
        { text: "Days Validity", available: true, value: 365 },
        { text: "Alerts & Notifications", available: true },
        { text: "ATS", available: true },
        { text: "Performance Analytical Report", available: true },
      ],
    },
    {
      id: "67cacdd8cc2bec83fe4e8ab3",
      name: "Advanced Plan",
      price: 7999,
      originalPrice: "₹8,499",
      features: [
        { text: "Resume Analyser", available: true, value: "∞" },
        { text: "AI Interviews", available: true, value: "∞" },
        { text: "Internship Guarantee", available: true, bold: true },
        { text: "Detailed Analytical Report", available: true },
        { text: "Days Interview Video Backup", available: true, value: 60 },
        { text: "Unlimited Job Application", available: true },
        { text: "Profile Boost", available: true },
        { text: "Premium Account Badge", available: true },
        { text: "MCQ's", available: true, value: "∞" },
        { text: "Days Validity", available: true, value: 365 },
        { text: "Alerts & Notification", available: true },
        { text: "ATS", available: true },
        { text: "Performance Analytical Report", available: true },
      ],
    },
    {
      id: 2,
      name: "Custom Plan",
      price: 0,
      // originalPrice: "₹18,499",
      features: [
        { text: "Resume Analyser", available: true },
        { text: "AI Interviews", available: true },

        { text: "Reports", available: true },
        { text: "ATS Dashboard", available: true },
        { text: "Tags", available: true },
        { text: "Salary recommendation", available: true },
        { text: "Proxy detection", available: true },
        { text: "Job Post", available: true },
        { text: "MCQ's", available: true },
        { text: "Login", available: true, value: 10 },
        { text: "Day Interview Backup", available: true },
        { text: "In App Auto Emails", available: true },
        { text: "White Labelling", available: true },
        { text: "Shared Support", available: true },
      ],
    },
  ];

  // useEffect(() => {
  //   const currentPath = loc.pathname;
  //   const matchedItem = coloumnList.find(item => item.action === currentPath);
  //   if (matchedItem) {
  //     setSelectedItem(matchedItem.label);
  //   }
  // }, [loc]);

  useEffect(() => {
    const currentPath = location.pathname;
    const matchedItem = coloumnList.find(
      (item) =>
        item.action === currentPath ||
        (item.url && item.url.some((url) => currentPath.includes(url)))
    );
    if (matchedItem) {
      setSelectedItem(matchedItem.label);
    }
  }, [location]);

  const toggleCollapse = () => {
    CommonStore.setCollapse(!CommonStore.collapse);
  };

  const handleCloseTechFusionHeader = () => {
    setShowTechFusionHeader(false);
  };

  // const Tooltip = () => {
  //   const [display, setDisplay] = useState(false);
  //   return (
  //     <div className="tooltip-container relative inline-block">
  //       <MdOutlineDashboard
  //         className="text-4xl cursor-pointer"
  //         size="1.5rem"
  //         onMouseEnter={() => setDisplay(true)}
  //         onMouseLeave={() => setDisplay(false)}
  //       />
  //       {display && (
  //         <div className="tooltip absolute bottom-[95%] -left-[100%] z-50  bg-primary2 text-black p-2 text-xs  rounded-lg ">
  //           Dashboard
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  // const Tooltip2 = () => {
  //   const [display, setDisplay] = useState(false);
  //   return (
  //     <div className="tooltip-container relative inline-block">
  //       <AiOutlineBook
  //         className="text-4xl cursor-pointer"
  //         size="1.5rem"
  //         onMouseEnter={() => setDisplay(true)}
  //         onMouseLeave={() => setDisplay(false)}
  //       />
  //       {display && (
  //         <div className="tooltip absolute bottom-[95%] -left-[50%] z-50  bg-primary2 text-black p-2 text-xs  rounded-lg ">
  //           Learn
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  // const Tooltip3 = () => {
  //   const [display, setDisplay] = useState(false);
  //   return (
  //     <div className="tooltip-container relative inline-block">
  //       <MdOutlineAccountCircle
  //         className="text-4xl cursor-pointer"
  //         size="1.5rem"
  //         onMouseEnter={() => setDisplay(true)}
  //         onMouseLeave={() => setDisplay(false)}
  //       />
  //       {display && (
  //         <div className="tooltip absolute top-[100%] -left-[50%] z-50  bg-primary2 text-black p-2 text-xs  rounded-lg ">
  //           Profile
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  // const Tooltip4 = () => {
  //   const [display, setDisplay] = useState(false);
  //   return (
  //     <div className="tooltip-container relative inline-block">
  //       <AiOutlineFileProtect
  //         className="text-4xl cursor-pointer"
  //         size="1.5rem"
  //         onMouseEnter={() => setDisplay(true)}
  //         onMouseLeave={() => setDisplay(false)}
  //       />
  //       {display && (
  //         <div className="tooltip absolute bottom-[95%] -left-[50%] z-50  bg-primary2 text-black p-2 text-xs  rounded-lg ">
  //           Resume Builder
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  const coloumnList = [
    {
      label: "Home",
      icon: (
        <Tooltip id="dashboardtooltip" position="top" content="Home">
          <GoHome
            className=" text-[25px] lg:text-[30px] lg:mx-5 cursor-pointer hidden md:block  "
            // size="2rem"
          />
        </Tooltip>
      ),
      show: view("home"),
      activeIcon: (
        <Tooltip id="dashboardtooltip" position="top" content="Home">
          {/* <GrHomeRounded  size="1.2rem" className="text-primary" /> */}
          <GoHome
            //  size="2rem"
            className="text-[25px] lg:mx-5 "
          />
        </Tooltip>
      ),
      action: "/dashboard/dashboard",
    },
    {
      label: "Jobs",
      show: view("Career"),
      url: [
        "/dashboard/career",
        "/dashboard/JobInternship/job-post/",
        "/dashboard/career-details",
        "/dashboard/career-info",
      ],
      icon: (
        <Tooltip id="carrertooltip" position="top" content="Jobs">
          <PiSuitcaseSimpleLight
            className="text-[25px]  lg:mx-5 cursor-pointer "
            // size="2rem"
          />
        </Tooltip>
      ),
      activeIcon: (
        <Tooltip id="carrertooltip" position="top" content="Jobs">
          <PiSuitcaseSimpleLight
            //  size="2rem"
            className="text-[25px] lg:mx-5 "
          />
        </Tooltip>
      ),
      action: "/dashboard/jobinternship",
    },
    {
      label: "My Jobs",
      show: view("job"),
      url: ["/dashboard/applications"],
      icon: (
        <Tooltip id="jobtooltip" position="top" content="Applications">
          <VscHistory
            className="text-[23px]   lg:mx-5 cursor-pointer "
            // size="2rem"
          />
        </Tooltip>
      ),
      activeIcon: (
        <Tooltip id="jobtooltip" position="top" content="Applications">
          <VscHistory
            // size="2rem"
            className="text-[23px] lg:mx-5 "
          />
        </Tooltip>
      ),
      action: "/dashboard/applications",
    },
    {
      label: "Mock Test",
      show: view("mock"),
      icon: (
        <Tooltip id="mocktooltip" position="top" content="Mock Test">
          <PiClipboardTextLight
            className="text-[25px]   lg:mx-5 cursor-pointer "
            // size="2rem"
          />
        </Tooltip>
      ),
      activeIcon: (
        <Tooltip id="mocktooltip" position="top" content="Mock Test">
          <PiClipboardTextLight
            //  size="2rem"
            className="text-[25px] lg:mx-5 "
          />
        </Tooltip>
      ),
      action: "/dashboard/mocktest",
    },
    // {
    //   label: "Learn",
    //   show: view("learn"),
    //   icon: (
    //     <Tooltip id="learntooltip" position="top" content="Learn">
    //       <AiOutlineRead
    //         className="  lg:mx-5 cursor-pointer"
    //         // size="1.5rem"
    //       />
    //     </Tooltip>
    //   ),
    //   url: ["/dashboard/course/"],
    //   activeIcon: (
    //     <Tooltip id="learntooltip" position="top" content="Learn">
    //       <AiOutlineRead
    //         // size="1.5rem"
    //         className="text-2xl lg:mx-5"
    //       />
    //     </Tooltip>
    //   ),
    //   action: "/dashboard/learn",
    // },
    {
      label: "Resume",
      show: view("resume"),
      icon: (
        <Tooltip id="resumetooltip" position="top" content="Resume-Builder">
          <IoDocumentTextOutline
            className=" text-2xl  lg:mx-5 cursor-pointer"
            // size="1.5rem"
          />
        </Tooltip>
      ),
      activeIcon: (
        <Tooltip id="resumetooltip" position="top" content="Resume-Builder">
          <IoDocumentTextOutline
            //  size="1.5rem"
            className="text-2xl lg:mx-5"
          />
        </Tooltip>
      ),
      action: "/dashboard/resumedetails",
    },

    {
      label: "Settings",
      show: view("profile"),
      url: ["/dashboard/report"],
      icon: (
        <Tooltip id="profiletooltip" position="top" content="Settings">
          {/* Use a conditional (ternary) operator to render the image or fallback icon */}
          {/* {profile ? ( */}
          {/* <img src={profile} className="m-1 rounded-full text-4xl w-3/4 cursor-pointer" alt="Profile" />*/}
          {/* <img
              src={`${profile}`}
              id="SidebarProfilePic"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = constantVariables.defaultProfilePic;
              }}
              alt=" "
              className="h-8 w-8 lg:h-[35px] lg:w-[40px] opacity-90 my-1 lg:m-0 rounded-full lg:text-8xl lg:mr-5 object-cover"
              style={{
                basckgroundColor: "#bebebe",

                // backgroundImage: `url(${defaultProfile})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
          ) : ( */}
          <IoSettingsOutline
            //  size="2rem"
            className="text-[25px] lg:mx-5 cursor-pointer "
          />
          {/* )} */}
        </Tooltip>
      ),
      activeIcon: (
        <Tooltip id="profiletooltip" position="top" content="Profile">
          {/* Use a conditional (ternary) operator to render the image or fallback icon */}
          {/* {profile ? (
            <img
              src={`${profile}`}
              id="SidebarProfilePic"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = constantVariables.defaultProfilePic;
              }}
              alt=" "
              className="h-8 w-8 lg:h-[35px] lg:w-[40px]  lg:m-0 rounded-full lg:text-8xl lg:mr-5 object-cover"
              style={{
                basckgroundColor: "gray",
                // backgroundImage: `url(${defaultProfile})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
          ) : ( */}
          <IoSettingsOutline
            // size="30px"
            className=" text-primary text-[25px]   lg:mr-5 w-3/4 lg:w-full ml-1 cursor-pointer object-cover "
          />
          {/* )} */}
        </Tooltip>
      ),
      action: "/dashboard/settings",
    },
  ];

  const getAllApis = () => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    UserStore.getUserDetails();
    LearningStore.getCourseListFromApi();
    console.log("userDetailas", userDetails);
    LearningStore.getEnrolledCoursesFromServer(userDetails?._id);
    // UserStore.fetchDashboardInterviews();
  };

  useEffect(() => {
    // if(JSON.parse(localStorage.getItem("user"))?.role?.role ==="company"){
    //   navigate("/company/dashboard")
    // }
    getAllApis();
  }, []);

  const getIconAsperUrl = (item) => {
    if (window.location.pathname === item.action) {
      return item?.activeIcon;
    } else {
      return item?.icon;
    }
  };

  const logOut = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("user_google");
    localStorage.clear();
    window.location.href = "/";
  };

  // useEffect( useObserver(() => {
  //   console.log(toJS(CommonStore.showHeaderInDashboard))
  // }),[])

  function showReferAndEarn() {
    PopupStore.setReferAndEarn(true);
  }
  const openGoogleForms = () => {
    window.location.href = banner.link;
  };

  return useObserver(() => (
    <div className="home-page-parent relative">
      {PopupStore.loginWarning && (
        <Popup
          popUpInitialValue={PopupStore.loginWarning}
          handlePopup={() => {
            PopupStore.setLoginWarning(false);
          }}
          image={loginWarningImage}
          content="Please login to access the content"
          buttontext="Signup now"
          onClick={() => {
            redirectToSignupPageWithCurrentUrl();
            PopupStore.setLoginWarning(false);
          }}
        />
      )}
      <header className="mt-20 md:mt-0 z-auto lg:mt-0 hidded md:block lg:block">
        {showTechFusionHeader ? (
          <div
            className=" bg-black text-white py-1 lg:h-6 flex items-center justify-center !h-6"
            style={{
              backgroundImage: `${banner?.backgroundColor}`,
            }}
          >
            <img
              src={banner?.image}
              className="w-4 h-4 mr-4  "
              alt="banner image"
            />
            <p className=" text-xs lg:py-6">
              <span className="font-semibold">{banner?.content} </span>
              <a
                onClick={openGoogleForms}
                className="cursor-pointer underline font-semibold px-1"
              >
                {banner?.buttonLabel}
              </a>{" "}
            </p>
            <button onClick={handleCloseTechFusionHeader}>
              <MdOutlineCancel className="ml-1 text-xs lg:text-lg text-white cursor-pointer" />
            </button>
            {/* <button className="ml-1 underline">View More</button> */}
          </div>
        ) : null}
      </header>
      <div className="lg:hidden md:hidden h-[90%] block">
        <MobileBottomNavBar />
      </div>

      <div className="md:flex hidden h-[100%] ">
        <Sidebar
          collapsed={CommonStore.collapse}
          transitionDuration={500}
          width={`${sidebarWidth} !important`}
          backgroundColor="black"
          border={`${
            sidebarWidth === "12%"
              ? "border-r-0 border-black"
              : "border-r-0 border-black"
          }`}
          className={`
z-[1000] bg-black m-0 md:block lg:block hidden !fixed p-0
`}
          style={{ borderRight: "1px solid black" }}
          // className={`bg-black z-[51]  !fixed `}
          onMouseEnter={() => {
            setSidebarWidth("12%");
            // CommonStore.setCollapse(false); // Expand on hover
            console.log("Mouse hovered");
          }}
          onMouseLeave={() => {
            setSidebarWidth("5%");
            // CommonStore.setCollapse(CommonStore.tempCollapse); // Revert to previous state
            console.log("Mouse left");
          }}
          // rootStyles={{
          //   [`.${sidebarClasses.container}`]: {
          //     width: "1000px",
          //   },
          // }}
        >
          <div className="py-5 hidden md:flex md:justify-between md:items-center w-full">
            <div
              className="py-4 hidden md:flex md:justify-center w-[90%] mx-2 h-20"
              onClick={handleLogoClick}
            >
              {sidebarWidth === "12%" ? (
                <img
                  src={getLogoBySubdomain()}
                  className="w-[90%] object-contain cursor-pointer"
                  alt="Large Logo"
                />
              ) : (
                <img
                  src={getSmallLogoForWhiteLabeling()}
                  className="w-[70%] cursor-pointer -my-5 object-contain"
                  alt="Small Logo"
                />
              )}
            </div>
          </div>
          <Menu
            className={`mt-[11%] ${
              sidebarWidth === "12%" ? "mx-[0%]" : "mx-0"
            }`}
          >
            {coloumnList.map((item, index) => {
              if (item.show === false) {
                return null; // Skip rendering this menu item if 'show' is false
              }
              const isSelected = selectedItem === item.label;
              return (
                <MenuItem
                  onClick={() => {
                    navigate(item.action);
                    setSelectedItem(item.label);
                  }}
                  key={index}
                  icon={getIconAsperUrl(item)}
                  className={`${
                    CommonStore.collapse ? "text-white" : "text-sm"
                  } items-center menu-item-sidebar md:h-12 lg:text-lg text-base ${
                    isSelected
                      ? "!text-primary border-l-4 border-[#F1EAE0] bg-black "
                      : " hover:bg-[#F1EAE0] border-l-4 border-[#000000] hover:text-[#ff6b00]"
                  }`}
                >
                  {sidebarWidth === "12%" ? item.label : null}
                </MenuItem>
              );
            })}
          </Menu>
          
          {name() !== "Naukritube" ? (
            <Menu className="absolute bottom-0 menu-item-sidebar">
              <tooltip
                id="premiumToolTip"
                position="top"
                content="Try Premium!"
              >
                <MenuItem
                  onClick={() => {
                    // if (activePlan) {
                    //   alert(
                    //     "You are already subscribed to a " +
                    //       activePlan.planId.name
                    //   );
                    //   return;
                    // }
                    navigate("/dashboard/subscription");
                  }}
                  icon={
                    <IoDiamondOutline
                      color="primary"
                      className=" transform text-primary text-2xl lg:text-4xl"
                    />
                  }
                  className={`${
                    CommonStore.collapse ? "text-[#999]" : "text-sm "
                  } flex items-center 0 lg:text-2xl text-primary`}
                >
                  <p
                    className={`${
                      sidebarWidth === "12%" ? "" : "hidden"
                    } font-semibold`}
                  >
                    {activePlan ? activePlan?.planId?.name : "Try Premium!"}
                  </p>
                </MenuItem>
              </tooltip>
            </Menu>
          ) : (
            <Menu className="absolute bottom-0 menu-item-sidebar">
              <tooltip
                id="premiumToolTip"
                position="top"
                content="Try Premium!"
              >
                <MenuItem
                  onClick={() => {
                    navigate("/dashboard/pricing-plans1");
                  }}
                  icon={
                    <IoDiamondOutline
                      color="primary"
                      className=" transform text-primary text-2xl lg:text-4xl"
                    />
                  }
                  className={`${
                    CommonStore.collapse ? "text-[#999]" : "text-sm "
                  } flex items-center 0 lg:text-2xl text-primary`}
                >
                  <p
                    className={`${
                      sidebarWidth === "12%" ? "" : "hidden"
                    } font-semibold`}
                  >
                    {"Try Premium!"}
                  </p>
                </MenuItem>
              </tooltip>
            </Menu>
          )}
        </Sidebar>

        <main className="items-start overflow-x-hidden menu-item-sidebar md:ml-[5%] lg:ml-[5%]">
          {/* {CommonStore.showHeaderInDashboard && header()} */}

          <div>
            <Routes className="router-parent">
              <Route path="/" element={<Dashboard />} />
              <Route path="/newone/:id" element={<JobPostReport />} />
              <Route path="/resume-analyzer" element={<ResumeAnalyzer />} />
              <Route path="/resume-analyzer-report" element={<Report />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/settings" element={<BasicDetails />} />
              <Route path="/learn" element={<Learn />} />
              <Route path="/mocktest" element={<CreateMockTest />} />
              <Route path="/english" element={<Mistakes />} />
              <Route path="/resumedetails" element={<ResumeTotal />} />
              <Route path="/resumetemplets" element={<ResumeTotal />} />
              <Route path="/career" element={<CareerLanding />} />
              <Route path="/myapplicants" element={<History />} />
              <Route path="/myapplicants/:id" element={<History />} />
              <Route path="/career-details" element={<CareerDetails />} />
              <Route path="/career-info/:tech" element={<Career />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route
                path="/interview-invitation"
                element={<MeetingCreationForm />}
              />
              <Route
                path="/meeting-creation-form"
                element={<MeetingCreationForm />}
              />

              <Route
                path="/JobInternship/*"
                element={<Internship />}
                children={<Route path="*" element={<Internship />} />}
              />
              <Route
                path="/applications"
                element={<HistoryPage />}
                children={<Route path="*" element={<HistoryPage />} />}
              />
              <Route path="/search" element={<AnimatedSearchBar />} />
              <Route
                path="/JobInternship/job-post/:id"
                element={<JobDetails />}
              />
              {/* <Route path="/settings" element={<div>profile</div>} /> */}
              <Route path="/report/:id" element={<ReportScreen />} />
              <Route path="/mockexamreport" element={<MockExamReport />} />
              <Route
                path="/course/:id"
                element={<LearninngTab hide={"false"} />}
              />
              <Route
                path="/subscription"
                element={
                  <Subscription commingFrom={"student"} plans={studentPlans} />
                }
              />
              <Route
                path="/pricing-plans1"
                element={<PricingPlans />}
              />
              <Route
                path="/subscription/successfull"
                element={<TransactionCards status={"success"} />}
              />
              <Route
                path="/subscription/failure"
                element={<TransactionCards status={"failure"} />}
              />
              <Route
                path="/subscription/pending"
                element={<TransactionCards status={"pending"} />}
              />
              <Route
                path="/pricing-plan"
                element={<PricePlan isStudent1={true} />}
              />
            </Routes>
          </div>
        </main>
      </div>
    </div>
  ));

  function header() {
    const openGoogleForms = () => {
      window.open("https://forms.gle/34Rpw6TL8iEfZRtS8", "_blank");
    };
    return (
      <>
        {" "}
        <div className=" z-50 fixed">
          {false && (
            <div className="">
              <div className="bg-black text-white py-1 flex items-center justify-center">
                <MdOutlineEmojiEvents className="mr-1 text-lg lg:text-2xl" />
                <p className="">
                  'Tech Fusion' hackathon! Join us in crafting innovative
                  solutions{" "}
                  <span
                    onClick={openGoogleForms}
                    className="cursor-pointer underline"
                  >
                    Apply now
                  </span>{" "}
                </p>
                {/* <button
              onClick={handleCloseTechFusionHeader}
                >
                  <MdOutlineCancel
              className="ml-1 text-lg lg:text-2xl text-white cursor-pointer"
               />   
             </button> */}
                {/* <button className="ml-1 underline">View More</button> */}
              </div>
            </div>
          )}
          <div className="row-auto flex flex-col m-0 items-center  h-14 bg-white w-full shadow-sm">
            {/* <div
        className="col-auto cursor-pointer "
        onClick={() => toggleCollapse()}
      >
        {!CommonStore.collapse ? (
          <FaBars className="text-2xl mx-2 " />
        ) : (
          <FaBars className="text-2xl mx-2" />
        )}
      </div> */}
            {/* */}
            <div className="flex items-center h-16 relative w-screen">
              <img
                className="h-[45px] py-2 ml-3"
                src={getLogoBySubdomain()}
                alt=""
              />
              {/* { CommonStore.collapse ?
        <div className="flex text-primary hover:bg-primary bg-primary2 border border-primary hover:text-white justify-center px-2 py-1 rounded-lg absolute right-24 cursor-pointer opacity-90" onClick={() => showReferAndEarn()}>
           <AiOutlineShareAlt  className="text-xl mr-1"/>
          <p className=" gil-med text-sm ">Refer & Earn</p>
       
        </div> :
        <div className="flex text-primary hover:bg-primary bg-primary2 hover:text-white border border-primary justify-center px-2 py-1 rounded-lg absolute right-48 cursor-pointer opacity-90" onClick={() => showReferAndEarn()}>
          <AiOutlineShareAlt className="text-xl mr-1"/>
          <p className=" gil-med text-sm ">Refer & Earn</p>
        
        </div>
        } */}
            </div>
          </div>
        </div>
        <div className="mt-0.5" />
      </>
    );
  }

  function profileSection() {
    return (
      <div
        className={`${
          CommonStore.collapse
            ? "flex flex-col"
            : "flex flex-col items-center justify-center w-full min-h-70 my-4 "
        }`}
      >
        <img
          // onClick={toggleCollapse}
          src={profile}
          alt=" "
          className={` ${
            CommonStore.collapse ? "profileImg mt-1" : "profileImg2"
          } rounded-full mt-2 w-36 h-36 shadow mx-auto object-cover`}
          style={{
            backgroundImage: `url(${defaultProfile})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <h1
          className={` ${
            CommonStore.collapse ? "small mt-1 ml-3" : "h-4 mt-2 "
          }  gil-med `}
        >
          {UserStore?.userDetails?.name}
        </h1>
        {/* <p className={`text-${collapse ? "sm ml-3" : "base"} text-gray-500`}>
                    Admin
                </p> */}
      </div>
    );
  }
}
